import "core-js/modules/es6.array.find";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import draggable from "vuedraggable";
export default {
  name: "topicC",
  components: {
    draggable: draggable
  },
  props: ["childModules", "homeModules"],
  data: function data() {
    return {};
  },
  created: function created() {},
  computed: {},
  methods: {
    addClick: function addClick(data) {
      this.$emit("addClick", data);
    },
    ifSelected: function ifSelected(val) {
      var topicModule = this.homeModules.find(function (item) {
        return item.cardType === "TOPIC";
      });

      if (topicModule) {
        if (topicModule.cardModules[0].data) {
          return topicModule.cardModules[0].data.some(function (item) {
            return item.topicId === val.topicId;
          });
        }

        return false;
      }

      return false;
    }
  },
  watch: {},
  filters: {}
};